import { render, staticRenderFns } from "./LeadsVsOpportunitiesByIndustry.vue?vue&type=template&id=c91a5a36&"
import script from "./LeadsVsOpportunitiesByIndustry.vue?vue&type=script&lang=js&"
export * from "./LeadsVsOpportunitiesByIndustry.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports